/**
 * SCO-726: what the code screens say when a verified code did not open a
 * session. PHP answers `reason: 'no_account'` (sign-in never creates an
 * account; the visitor may register) or `'deactivated'` (a replacement office
 * is never created either). Anything else is the plain bad-code failure.
 */
export var LOGIN_DENIAL_MESSAGES = {
    no_account: 'No account for that email. Check the address, or create an account below.',
    deactivated: 'This account has been deactivated. Ask your coach to reactivate it.'
};
export var loginDenialMessage = function (reason) { return ((reason && LOGIN_DENIAL_MESSAGES[reason]) || 'Invalid code.'); };
